import { React, useRef } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';

export default function PrintInput(props) {
  const { value, setValue } = props;
  const { t } = useLanguage();

  const InputRef = useRef();

  function onChangeInput(e) {
    const curValue = e.target.value
		const newValue = curValue.replace(/[^0-9]/g, '')

		setValue(newValue);
  }

  function onFocusInput() {
  }

  function onBlurInput() {
  }

  return (
    <TopLevelWrapper>
      <LayerWrapper>
        <Input 
          ref={InputRef}
          placeholder='0'
          value={value || ''}
          // disabled={disabled}
          onFocus={onFocusInput}
          onChange={onChangeInput}
          onBlur={onBlurInput}/>
      </LayerWrapper>
      <LayerWrapper>
        <Text>{t('settingProduct.currencyUnit')}</Text>
      </LayerWrapper>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;

  gap: 8px;
`;

const LayerWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const Input = styled.input`
  padding: 0 10px;

  box-sizing: border-box;
  width: 169px;
  height: 35px;

  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;
  outline: none;

  color: ${props => props.theme.text};
  background-color: ${props => props.theme.subBackground};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  transition: all 0.3s ease-in-out;

  ::placeholder {
    color: ${props => props.theme.gray};
  }
`;

const Text = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 12px;

  color: ${props => props.theme.subText};

  margin: 0 8px 0 0;
`;
